import {Col, Divider, Icon, Row, Typography} from "@bezlimit/bezlimit-ui";
import React, {useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import Clipboard from "react-clipboard.js";
// core
import date from "../../../../../core/functions/date";
import {SVGWITHDEFS} from "../../../../../utils";

export default function ListColapse({
    id,
    status_name,
    created_at,
    track_number,
    status,
    shipped_at
}: IProps) {
    const {t} = useTranslation();
    const dateFormat: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "numeric",
        day: "numeric"
    };

    const [disabled, setDisabled] = useState(false);
    const timeout: any = useRef();

    const onSuccess = async () => {
        clearTimeout(timeout.current);
        setDisabled(true);
        timeout.current = setTimeout(() => {
            setDisabled(false);
        }, 3000);
    };

    return (
        <Typography as="div" className="bl-widget-delivery-list">
            <Row gutter={[16, 32]}>
                <Col md={1} xs={0} className="img-status">
                    <Typography as="div">
                        {SVGWITHDEFS.includes(status) ? (
                            <Icon name={`status_${status}`} size="15" />
                        ) : (
                            <Icon name={`status_${status}`} size="15" />
                        )}
                    </Typography>
                </Col>

                <Col md={5} xs={12}>
                    <Typography className="delivery-list-sub-title">{t("Код доставки")}</Typography>
                    <Typography as="div" size={17} className="delivery-list-id copyable">
                        <Typography className="lattice">{t("#")}</Typography>
                        <Typography className="mobile-img">
                            {SVGWITHDEFS.includes(status) ? (
                                <svg width="15" height="15">
                                    <use href={`#${status}`} />
                                </svg>
                            ) : (
                                <Icon name={`status_${status}`} size="15" />
                            )}
                        </Typography>
                        <Typography className="id-list">{id}</Typography>
                    </Typography>
                </Col>
                <Col md={8} xs={12}>
                    <Typography className="delivery-list-sub-title">{t("Статус")}</Typography>
                    <Typography size={17} color="rgba(255, 255, 255, 0.5)" className="status-name">
                        {status_name}
                    </Typography>
                </Col>
                <Col md={5} xs={12}>
                    <Typography className="delivery-list-sub-title">
                        {t("Дата отправки")}
                    </Typography>
                    <Typography size={17} className="date-created-at">
                        {date(shipped_at, dateFormat)}
                    </Typography>
                </Col>
                <Col md={5} xs={12}>
                    <Typography className="delivery-list-sub-title">
                        {t("Номер отслеживания")}
                    </Typography>
                    <Typography size={17} className="track-number">
                        <Clipboard
                            component="span"
                            data-clipboard-text={`${track_number ?? "не определен"}`}
                            onSuccess={onSuccess}
                        >
                            {t(disabled ? "Скопировано" : track_number)}
                        </Clipboard>
                    </Typography>
                </Col>
                <Divider />
            </Row>
        </Typography>
    );
}

interface IProps {
    id: number;
    status_name: string;
    created_at: string;
    track_number: string;
    status: string;
    shipped_at: string;
}
